import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-required-fields-error',
  imports: [
    MatDialogModule,
    TranslatePipe,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './required-fields-error.component.html',
  styleUrl: './required-fields-error.component.scss',
})
export class RequiredFieldsErrorComponent {

}
